import styled from 'styled-components'

export const HeaderContainer = styled.div`
  margin-bottom: 18px;
`
